import { Box, Heading } from '@chakra-ui/react';
import { FC } from 'react';
import PARAGRAPH_MAPPING from '../../../config/paragraph-mapping';
import { ParagraphSidebarBlockFragment } from '../../../generated/types';

interface SidebarBlockProps {
  data: ParagraphSidebarBlockFragment;
  isInArticleLayout?: boolean;
}

export const SidebarBlock: FC<SidebarBlockProps> = ({
  data,
  isInArticleLayout,
}) => {
  if (!data.content?.length) {
    return null;
  }

  return (
    <Box>
      {data.title && (
        <Heading mb={2} fontSize="2xl">
          {data.title}
        </Heading>
      )}
      {data.content?.map((data, i) => {
        if (PARAGRAPH_MAPPING[data.__typename]) {
          const Component = PARAGRAPH_MAPPING[data.__typename];
          const ComponentItem = (
            <Component
              key={i}
              data={data}
              isInArticleLayout={isInArticleLayout}
            />
          );

          return ComponentItem;
        }

        return null;
      })}
    </Box>
  );
};

export default SidebarBlock;
